import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import { countryCodes, stateCodes, provinceCodes } from '../../../Utils/Consts';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { StyledButton } from '../../../Components/Generics.styled';

const AddAnAdvertiserContainer = styled.div`
    display: flex;
    height: 800px;
    width: 900px;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 30px;
    margin-bottom: 25px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const RowContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    width: 800px;
    justify-content: space-evenly;
`;
const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    width: 350px;
`;

const StyledDropdown = styled.div``;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const SwitchSection = styled.div`
    margin-top: 15px;
`;

const SwitchLabel = styled.span`
    letter-spacing: 0px;
    color: #000000;
`;
const SwitchSubLabel = styled.div`
    font: italic normal normal 16px/19px Roboto;
    letter-spacing: 0px;
    color: #6f6f6f;
`;

const RadioSection = styled.div`
    .MuiFormGroup-root {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
`;

const SwitchContainer = styled.div`
    display: flex;
`;

const AddAdvertiserModal = (props) => {
    const {
        modalIsOpen,
        mutate,
        postData,
        handleClose,
        newAdvertiser,
        setNewAdvertiser,
        createNewAdvertiser,
        resetFields,
    } = props;

    const {
        isAgencyManager,
        agencyId,
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        country,
        city,
        province,
        zipCode,
    } = { ...newAdvertiser };

    const handleCloseModal = () => {
        resetFields();
        handleClose();
    };

    const disableAddButton =
        companyName === '' ||
        firstName === '' ||
        lastName === '' ||
        primaryPhone === '' ||
        mobilePhone === '' ||
        streetAddress === '' ||
        city === '' ||
        province === '' ||
        country === '' ||
        zipCode === '';

    const body = (
        <div style={style}>
            <AddAnAdvertiserContainer>
                <Title>Add Advertiser</Title>
                {/* <AddAdvertiserApplet> */}
                <RowContainer>
                    <StyledTextField
                        id="company-name"
                        label="Company Name"
                        value={companyName}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                companyName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={companyName === ''}
                    />
                    <StyledTextField
                        id="company-website"
                        label="Company Website"
                        value={companyWebsite}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                companyWebsite: e.target.value,
                            })
                        }
                        variant="outlined"
                    />
                </RowContainer>
                <br />
                <RowContainer>
                    <StyledTextField
                        id="first-name"
                        label="First Name"
                        value={firstName}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                firstName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={firstName === ''}
                    />
                    <StyledTextField
                        id="last-name"
                        label="Last Name"
                        value={lastName}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                lastName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={lastName === ''}
                    />
                </RowContainer>

                <br />
                <RowContainer>
                    <StyledTextField
                        id="primary-phone"
                        label="Primary Phone"
                        value={primaryPhone}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                primaryPhone: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={primaryPhone === ''}
                    />
                    <StyledTextField
                        id="mobile-phone"
                        label="Mobile Phone"
                        value={mobilePhone}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                mobilePhone: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={mobilePhone === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledTextField
                        style={{ width: '733px' }}
                        id="title"
                        label="Your Title"
                        value={title}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                title: e.target.value,
                            })
                        }
                        variant="outlined"
                    />
                </RowContainer>
                <br />

                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledTextField
                        style={{ width: '733px' }}
                        id="street-address"
                        label="Street Address"
                        value={streetAddress}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                streetAddress: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={streetAddress === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledDropdown>
                        <FormControl required error={country === ''} variant="outlined">
                            <InputLabel id="country-dropdown">Country</InputLabel>
                            <Select
                                style={{ marginRight: '15px', width: '240px' }}
                                labelId="country-dropdown"
                                id="country-dropdown"
                                value={country}
                                onChange={(e) =>
                                    setNewAdvertiser({
                                        ...newAdvertiser,
                                        country: e.target.value,
                                        state: '',
                                    })
                                }
                                label="country"
                            >
                                {countryCodes.map((item, idx) => (
                                    <MenuItem key={idx} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>

                    <StyledTextField
                        style={{ marginRight: '15px', width: '240px' }}
                        id="city"
                        label="City"
                        value={city}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                city: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={city === ''}
                    />
                    <StyledDropdown>
                        <FormControl
                            disabled={country === ''}
                            required
                            error={country !== '' && province === ''}
                            variant="outlined"
                        >
                            <InputLabel id="state-or-province">
                                {country === 'USA' ? 'State' : 'Province'}
                            </InputLabel>
                            <Select
                                style={{ marginRight: '15px', width: '120px' }}
                                labelId="state-or-province"
                                id="state-or-province"
                                value={province}
                                onChange={(e) =>
                                    setNewAdvertiser({
                                        ...newAdvertiser,
                                        province: e.target.value,
                                    })
                                }
                                label="state"
                            >
                                {country === 'USA'
                                    ? stateCodes.map((item, idx) => (
                                          <MenuItem key={idx} value={item}>
                                              {item}
                                          </MenuItem>
                                      ))
                                    : provinceCodes.map((item, idx) => (
                                          <MenuItem key={idx} value={item}>
                                              {item}
                                          </MenuItem>
                                      ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>

                    <StyledTextField
                        style={{ width: '90px' }}
                        id="zipcode"
                        label="Zipcode"
                        value={zipCode}
                        onChange={(e) =>
                            setNewAdvertiser({
                                ...newAdvertiser,
                                zipCode: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={zipCode === ''}
                    />
                </RowContainer>
                <br />
                {/* <RowContainer style={{ justifyContent: 'unset', paddingLeft: '40px' }}>
                    <SwitchContainer>
                        <SwitchSection>
                            <SwitchLabel>*Is this a manager?</SwitchLabel>
                            <SwitchSubLabel>Will you be managing this agency?</SwitchSubLabel>
                        </SwitchSection>
                        <RadioSection>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    aria-label="accountType"
                                    name="accountType"
                                    value={isAgencyManager ? true : false}
                                    onChange={(e) =>
                                        setNewAdvertiser({
                                            ...newAdvertiser,
                                            isAgencyManager: !isAgencyManager,
                                        })
                                    }
                                >
                                    <FormControlLabel
                                        value={true}
                                        control={
                                            <Radio
                                                style={{
                                                    color:
                                                        isAgencyManager === '' ? 'red' : '#3F51B5',
                                                }}
                                            />
                                        }
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        value={false}
                                        control={
                                            <Radio
                                                style={{
                                                    color:
                                                        isAgencyManager === '' ? 'red' : '#3F51B5',
                                                }}
                                            />
                                        }
                                        label="No"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </RadioSection>
                    </SwitchContainer>
                </RowContainer> */}

                <br />
                <br />
                <div>{postData?.message}</div>
                <StyledNavButtons>
                    <StyledButton onClick={() => handleCloseModal()}>Cancel</StyledButton>
                    <StyledButton onClick={() => createNewAdvertiser()} disabled={disableAddButton}>
                        {postData.isLoading ? (
                            <CircularProgress
                                style={{ height: '20px', width: '20px', color: 'white' }}
                                color="primary"
                            />
                        ) : (
                            'Save'
                        )}
                    </StyledButton>
                </StyledNavButtons>
            </AddAnAdvertiserContainer>
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

AddAdvertiserModal.propTypes = {
    modalIsOpen: propTypes.bool,
    handleClose: propTypes.func,
    advertisers: propTypes.shape({}),
    mutate: propTypes.func,
    resetFields: propTypes.func,
    createNewAdvertiser: propTypes.func,
    newAdvertiser: propTypes.shape({}),
    setNewAdvertiser: propTypes.func,
    postData: propTypes.shape({
        isLoading: propTypes.bool,
        success: propTypes.bool,
        error: propTypes.bool,
        message: propTypes.array,
    }),
};

AddAdvertiserModal.defaultProps = {
    advertisers: {},
    // setAdvertisers: () => {},
    mutate: () => {},
    postData: {
        isLoading: false,
        success: false,
        error: false,
        message: [''],
    },
};
export default AddAdvertiserModal;
